<!-- 增加页面 -->
<template>
    <div>
        <el-form>
        <el-row>
            <el-col :span="6">
                <el-form-item label="请选择保险公司">
                <el-select size="mini" v-model="insuranceId" placeholder="请选择保险公司">
                    <el-option  
                    v-for="item in insuranceOptions"  
                    :key="item.id"  
                    :label="item.insureCompanyName"
                    :value="item.id">
                    </el-option>  
                </el-select>
                <el-button type="primary" size="mini" @click="getInsuranceList">刷新</el-button>
                </el-form-item>
                
            </el-col>
         
            <el-col > 
                <el-button type="primary" icon="el-icon-plus" @click="doOneKeyAccess" size="mini">一键获取数据</el-button>
            </el-col>

            <el-col>
                <el-button type="primary" @click="doTestUpdateBidStatus" size="mini"> 测试更新中标状态</el-button>
            </el-col>
        </el-row>
        </el-form>
    </div>
</template>
<script>
import {setNewCaseListByApi,testUpdateBidStatus} from '@/api/vehicle/case-online-api'
import {listInsurance} from '@/api/vehicleConfig/insurance'

export default{
    name: "Api-Online",//车辆保险 列表
    data(){
        return{
            insuranceId:'',
            insuranceOptions:[],
        }
    },
    created(){
        this.getInsuranceList();
    },
    methods:{
        doTestUpdateBidStatus(){
            testUpdateBidStatus()
            .then(res=>{
                    console.log(res);
            })
            .catch(error=>{

            })
        },
        //获取保险公司列表
        getInsuranceList(){
            listInsurance()
            .then(res=>{
                
                this.insuranceOptions=res.data;
            })
            .catch(error=>{
                console.log(error);
            })
        },
        doOneKeyAccess(){
            console.log(this.insuranceId);
            if(this.insuranceId<=0 || this.insuranceId=="undefined"){
                this.$modal.msgError("请选择保险公司");
                return
            }
            setNewCaseListByApi({'insureId':this.insuranceId}).then(
                res=>{
                   
                    if(res.success){
                        this.$modal.msgSuccess("获取成功");
                    }else{
                        this.$modal.msgError("获取部分数据失败");
                    }
                }
            )
        }
    }
}

</script>